/** Agent routing keywords (MHS-627), cleaned up the same way the backend reads them. */

const MAX_KEYWORDS = 10;
const KEYWORD_CHARS = 40;

export function parseRoutingKeywords(text: string): string[] {
  const keywords: string[] = [];
  const seen = new Set<string>();
  for (const part of text.split(",")) {
    const keyword = part.split(/\s+/).filter(Boolean).join(" ").slice(0, KEYWORD_CHARS);
    if (keyword && !seen.has(keyword.toLowerCase())) {
      seen.add(keyword.toLowerCase());
      keywords.push(keyword);
    }
  }
  return keywords.slice(0, MAX_KEYWORDS);
}

export function formatRoutingKeywords(value: unknown): string {
  if (!Array.isArray(value)) return "";
  return value.filter((keyword): keyword is string => typeof keyword === "string").join(", ");
}

/** Same keywords in the same order, ignoring case. */
export function sameRoutingKeywords(a: string[], b: string[]): boolean {
  return a.length === b.length && a.every((keyword, i) => keyword.toLowerCase() === b[i].toLowerCase());
}
